import React from 'react';
import {
  IconDataflow,
  IconTerminal,
  IconShieldTick,
  IconBankNote,
  IconAdd,
  IconAiPencil,
  IconStarMoving,
  IconDashboard,
  IconMail,
  IconMenu,
  IconSites,
  IconSupport,
  IconTools,
  IconN8N,
  IconRobot,
  IconClock,
  IconChatCheck,
  IconMegaphone,
  IconBag,
  IconOpenClaw,
  IconStarsBright,
  IconClockCheck,
  IconPaint,
  IconDomain,
  IconLink,
  IconPlayer,
  IconBlogRight,
  IconQuestion,
  IconServer,
  // IconShield,
} from 'gatorcomponents';
import VpsN8nImage from '@/pages/Home/media/vps-n8n.png';
import VpsOpenClawImage from '@/pages/Home/media/vps-open-claw.png';
import WordPressAIImage from '@/pages/Home/media/wordpress-ai.png';
import SiteBuilderV2Image from '@/pages/Home/media/site-builder-v2.png';
import EmailTitanImage from '@/pages/Home/media/email-titan.png';
import AiAgentsImage from '@/pages/Home/media/ai-agents.png';
import { PRODUCTS_HIGHLIGHT_IDS } from '../../pages/Home/HomeHandler.enum';
import { formatCurrency } from '@/utils/Formatters/formatCurrency';
import { OPTIONS } from '@/components/Layout/Menu/HeaderV2/components/NewAiHeaderButton/NewAiHeaderButton.types';
import { SITE_HG } from '@/config';
import { HOSTING_URL } from '@/config/urls/hostingUrls';
import { REGISTER_DOMAIN_URL } from '@/config/urls/domainsUrls';

const n8nPrice = 25.89;

export default {
  aiConversationBanner: {
    betaTag: 'Beta',
    title: (name = '') => `Olá, ${name}. O que você quer que eu faça hoje?`,
    input: {
      placeholderAlreadyOpened: 'Você já tem um chat aberto com o Gator',
      placeholder: 'Pergunte ou peça ao Gator para fazer alguma coisa...',
    },
    audio: {
      recordingLabel: 'Ouvindo...',
      transcribingLabel: 'Gerando Transcrição...',
    },
    suggestions: [
      {
        Icon: IconDashboard,
        id: 'create-site',
        label: 'Criar site',
        initialMessage: 'Me ajude a criar um novo site',
        action: 'newSite',
        value: OPTIONS.CREATE_SITE,
      },
      {
        Icon: IconMail,
        id: 'create-email',
        label: 'Criar e-mail',
        initialMessage: 'Me ajude a criar um e-mail profissional',
        action: 'email',
        value: OPTIONS.CREATE_EMAIL,
      },
      {
        Icon: IconAdd,
        id: 'contract-domain',
        label: 'Contratar domínio',
        initialMessage: 'Quero contratar um domínio',
        value: OPTIONS.DOMAIN_PURCHASE,
      },
      {
        Icon: IconStarMoving,
        id: 'marketing-tips',
        label: 'Marketing',
        initialMessage: 'Liste as formas em que você pode me ajudar com marketing',
        value: OPTIONS.MARKETING_TIPS,
        hidden: true,
      },
      {
        Icon: IconSupport,
        id: 'support',
        label: 'Suporte',
        value: OPTIONS.SUPPORT,
        initialMessage: 'Preciso de suporte',
      },
      {
        Icon: IconMenu,
        id: 'more',
        label: 'Mais',
        action: 'expand',
        value: OPTIONS.MORE,
      },
      {
        Icon: IconSites,
        hideOnInit: true,
        id: 'configure-domain',
        label: 'Configurar domínio (DNS)',
        initialMessage: 'Configure o meu domínio',
        action: 'domainConfig',
        value: OPTIONS.CONFIGURE_DOMAIN,
      },
      {
        Icon: IconTools,
        hideOnInit: true,
        id: 'check-account',
        label: 'Checar minha conta',
        initialMessage: 'Faça um diagnóstico da minha conta',
        value: OPTIONS.CHECK_ACCOUNT,
      },
      {
        Icon: IconAiPencil,
        hideOnInit: true,
        id: 'create-posts',
        label: 'Criar posts',
        initialMessage: 'Me ajude a criar mensagens para posts nas redes sociais',
        value: OPTIONS.CREATE_POSTS,
      },
      {
        Icon: IconBag,
        hideOnInit: true,
        id: 'contract-product',
        label: 'Contratar produto',
        initialMessage: 'Quero contratar um novo produto',
      },
    ],
  },
  greetingBanner: {
    title: (name = '') => (
      <>
        Olá,
        {' '}
        <strong>{name}</strong>
        !
      </>
    ),
    subtitle: 'Que bom ter você por aqui!',
    cta: {
      label: 'Criar site',
      link: '/sites/criar-site',
    },
  },
  bannerAiAgent: {
    popover: {
      title: 'Sou uma Inteligência Artificial',
      description: 'Eu faço seu site ficar pronto rapidinho! Quer ver como é fácil?',
      buttonLabel: 'Entendi',
    },
  },
  VinculedGoogle: {
    title: 'Sucesso na vinculação de conta com o Google!',
    message: 'Agora você poderá logar com seu usuário e senha ou diretamente pelo Google',
  },
  ContractedProducts: {
    hosting: {
      title: 'Hospedagens',
      buttonGoToLabel: 'Ir para Hospedagem',
      empty: {
        title: 'Hospede o seu site com qualidade e conquiste o mundo digital!',
        subtitle: 'Escolha uma hospedagem confiável e leve o seu negócio para o próximo nível.',
        buttonLabel: 'Contratar hospedagem',
      },
    },
    domain: {
      title: 'Domínios',
      buttonGoToLabel: 'Ir para Domínio',
      empty: {
        title: 'Garanta o seu domínio agora e destaque-se online!',
        subtitle: 'Cadastre já o seu domínio e leve o seu negócio para o próximo nível.',
        buttonLabel: 'Contratar domínio',
      },
    },
    buttonLabelManage: 'Gerenciar',
    expiresOn: 'Expira em',
    hostingStatus: {
      pending: 'Pendente',
      active: 'Ativo',
      completed: 'Completo',
      suspended: 'Suspenso',
      terminated: 'Encerrado',
      cancelled: 'Cancelado',
      fraud: 'Fraude',
      building: 'Em Configuração',
      activationPending: 'Aguardando ativação',
    },
  },
  infosMenuHighlight: {
    tagNew: 'Novo',
    studioGuide: {
      title: 'Conheça o HostGator Studio',
      description: 'Aproveite a funcionalidade do Studio para criar conteúdos grátis para o seu negócio.',
    },
    staticHighlights: [
      {
        id: PRODUCTS_HIGHLIGHT_IDS.HG_BUILDER,
        size: 100,
        name: 'HostGator Builder',
        title: 'Criador de Sites',
        subtitle: 'Chegou o Novo Criador de Sites com IA',
        description: 'Sem códigos. Sem complicação. Só resultados. Você fala, a IA faz. Sua empresa online? Só aqui!',
        link: '/sites/criar-site',
        image: SiteBuilderV2Image,
        cta: 'Criar meu site',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Crie seu site',
          icon: <IconDashboard color="primaryExtraDark" />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.SITE_CREATOR,
        size: 100,
        name: 'HighLightProduct',
        title: 'WordPress',
        subtitle: 'Tenha um site pronto para vender mais!',
        description: 'Nosso WordPress com IA faz tudo pra você: textos, imagens, design, sem complicações! Você só precisa alterar se quiser.',
        link: '/sites/criar-site',
        image: WordPressAIImage,
        cta: 'Criar meu site',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Crie seu site',
          icon: <IconDashboard color="primaryExtraDark" />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.EMAIL_TITAN,
        size: 100,
        name: 'HighLightProduct',
        title: 'E-mail Titan',
        subtitle: 'Tenha um e-mail com o nome da sua marca!',
        description: 'Ganhe a confiança dos seus clientes. Crie contas para cada equipe e marque reuniões com calendário.',
        tag_color: '#FFCF00',
        link: 'open_merlin',
        image: EmailTitanImage,
        cta: 'Criar e-mail',
        link_open_behavior: 'function',
        menu: {
          title: 'E-mail Profissional',
          icon: <IconMail color="primaryExtraDark" />,
        },
      },
      {
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.AI_AGENTS,
        size: 100,
        name: 'Agentes de IA',
        subtitle: 'Só no Criador de Sites: aproveite agora!',
        title: 'Tenha um Agente de IA que atende para você',
        badge: 'Grátis no seu plano',
        image: AiAgentsImage,
        cta: 'Quero meu agente',
        descriptionList: [
          {
            icon: <IconChatCheck color="lowPure" />,
            text: 'Responder dúvidas em segundos.',
            id: 'reply',
          },
          {
            icon: <IconMegaphone color="lowPure" />,
            text: 'Apresentar seus produtos e serviços.',
            id: 'show_products',
          },
          {
            icon: <IconClock color="lowPure" />,
            text: 'Atendimento 24 horas por dia',
            id: '24_hours_support',
          },
        ],
        menu: {
          title: 'Crie seu Agente de IA',
          icon: <IconRobot color="primaryExtraDark" />,
        },
        flag_new: 1,
      },
      {
        // Note: This object id is not returned by the API
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.VPS_N8N,
        size: 100,
        name: 'HighLightProduct',
        title: 'Servidor VPS n8n',
        description: 'Crie e rode suas automações em minutos',
        descriptionPrefix: (price = n8nPrice) => `a partir de ${formatCurrency(price)}/mês`,
        descriptionList: [
          {
            icon: <IconDataflow color="lowPure" />,
            text: 'Fluxos de trabalho e integrações ilimitadas',
            id: 'dataflow',
          },
          {
            icon: <IconTerminal color="lowPure" />,
            text: 'Acesso root e liberdade para customizar',
            id: 'terminal',
          },
          {
            icon: <IconShieldTick color="lowPure" />,
            text: 'Ambiente isolado e confiável',
            id: 'shield',
          },
          {
            icon: <IconBankNote color="lowPure" />,
            text: 'Sem cobranças por tarefas ou limites de uso',
            id: 'banknote',
          },
        ],
        link: '/sites/criar-site',
        image: VpsN8nImage,
        cta: 'Conhecer VPS n8n',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Servidor VPS n8n',
          icon: <IconN8N color="primaryExtraDark" />,
        },
      },
      {
        // Note: This object id is not returned by the API
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.VPS_OPEN_CLAW,
        size: 100,
        name: 'HighLightProduct',
        title: 'Servidor VPS OpenClaw',
        subtitle: (
          <>
            Coloque um
            {' '}
            <span>agente de IA</span>
            {' '}
            para agir por você
          </>
        ),
        description: 'Automatize tarefas, integre plataformas e reduza o trabalho manual. O OpenClaw executa processos de forma autônoma e trabalha continuamente para você no seu dia a dia.',
        link: `${SITE_HG}/servidor-vps/openclaw`,
        image: VpsOpenClawImage,
        cta: 'Conhecer VPS OpenClaw',
        link_open_behavior: 'new_tab',
        menu: {
          title: 'Servidor VPS OpenClaw',
          icon: <IconOpenClaw color="primaryExtraDark" />,
        },
        flag_new: 1,
      },
    ],
  },
  infosLoadingError: {
    buttonLabel: 'Recarregar Página',
    message: (
      <>
        Ocorreu um erro ao carregar a página
        {' '}
        <br />
        Caso persista, tente novamente mais tarde.
      </>
    ),
  },
  v2: {
    banner: {
      title: 'Temos tudo que você precisa para acelerar seu negócio:',
      listTitle: 'Seu site criado com IA',
      list: [
        { text: 'Em minutos, o site do seu negócio pronto, hoje', icon: <IconClockCheck color="primaryExtraDark" /> },
        { text: 'Diga como quer e nossa IA faz tudo', icon: <IconStarsBright color="primaryExtraDark" /> },
        { text: 'Seu site com cores, design, textos e muito mais', icon: <IconPaint color="primaryExtraDark" /> },
      ],
      cta: 'Criar site com IA',
    },
    readyProductsCarousel: {
      title: 'Produtos prontos para você usar e fazer seu negócio acontecer',
      description: 'Cada solução ajuda o seu negócio a ser encontrado e a gerar resultados mais rápidos online.',
      email: {
        id: 'email',
        title: 'Criar e-mail',
        description: 'Quer a confiança dos seus clientes? Tenha um e-mail profissional.',
        icon: <IconMail color="primaryMedium" />,
        cta: 'Criar e-mail',
      },
      linkInBio: {
        id: 'linkInBio',
        title: 'Link na Bio',
        description: 'Tenha um link com todos os acessos do seu site, contatos e redes sociais.',
        icon: <IconLink color="primaryMedium" />,
        cta: 'Criar Link na Bio',
      },
      createAgent: {
        id: 'createAgent',
        title: 'Criar Agente',
        description: 'Seu cliente sempre atendido no site e WhatsApp por seu Agente de IA.',
        icon: <IconRobot color="primaryMedium" />,
        cta: 'Criar Agente de IA',
      },
      marketing: {
        id: 'marketing',
        title: 'Agente de Marketing',
        description: 'Crie anúncios que vendem. Turbine seus posts e se destaque.',
        icon: <IconMegaphone color="primaryMedium" />,
        cta: 'Criar Agente de Marketing',
      },
      // monarx: {
      //   id: 'monarx',
      //   title: 'Monarx',
      //   description: 'Proteja seu site contra ameaças e mantenha tudo seguro.',
      //   icon: <IconShield color="primaryMedium" />,
      //   cta: 'Adquirir Monarx',
      // },
      domain: {
        id: 'buyDomain',
        title: 'Domínio adicional',
        description: 'Ganhe mais alcance com um segundo domínio para divulgar seu site.',
        icon: <IconDomain color="primaryMedium" />,
        cta: 'Adquirir domínio',
      },
    },
    activeProductsCarousel: {
      title: 'Seus produtos ativos',
      hosting: {
        id: 'hosting',
        title: 'Hospedagem',
        icon: <IconServer color="primaryMedium" />,
      },
      domain: {
        id: 'domain',
        title: 'Domínio',
        icon: <IconDomain color="primaryMedium" />,
      },
      site: {
        id: 'site',
        title: 'Meu site',
        icon: <IconDashboard color="primaryMedium" />,
      },
      email: {
        id: 'email',
        title: 'Meu e-mail',
        icon: <IconMail color="primaryMedium" />,
      },
      linkInBio: {
        id: 'linkInBio',
        title: 'Link na Bio',
        icon: <IconLink color="primaryMedium" />,
      },
      createAgent: {
        id: 'createAgent',
        title: 'Criar Agente',
        icon: <IconRobot color="primaryMedium" />,
      },
      marketing: {
        id: 'marketing',
        title: 'Agente de Marketing',
        icon: <IconMegaphone color="primaryMedium" />,
      },
      // monarx: {
      //   id: 'monarx',
      //   title: 'Monarx',
      //   icon: <IconShield color="primaryMedium" />,
      // },
    },
    getUsedToTitle: 'Fique por dentro!',
    cardsGetUsedTo: [
      {
        id: 'courses',
        icon: <IconPlayer color="primaryBlue" />,
        title: 'Cursos gratuítos com certificados',
        description: 'Aprende com especialistas a transformar seu negócio em presença digital.',
        cta: 'Acessar',
      },
      {
        id: 'blog',
        icon: <IconBlogRight color="primaryBlue" />,
        title: 'HostGator Blog',
        description: 'Dicas, instruções e tutoriais imperdíveis.',
        cta: 'Acessar',
      },
      {
        id: 'help',
        icon: <IconQuestion color="primaryBlue" />,
        title: 'Central de ajuda',
        description: 'Tem algum dúvida? A gente te ajuda!',
        cta: 'Acessar',
      },
    ],
    emptyProducts: {
      title: 'A melhor hospedagem e domínio para o seu site',
      items: [
        {
          id: 'hosting',
          icon: <IconServer color="primaryBlue" size="sm" />,
          title: 'Hospede o seu site',
          description: 'Segurança total, preparada para suportar picos de acesso e manter seu site sempre disponível.',
          cta: 'Hospedar meu site',
          link: HOSTING_URL,
        },
        {
          id: 'domain',
          icon: <IconSites color="primaryBlue" size="sm" />,
          title: 'Garanta o seu domínio',
          description: 'Registre já o seu domínio e começa a destacar o nome do seu negócio online.',
          cta: 'Registrar meu domínio',
          link: REGISTER_DOMAIN_URL,
        },
      ],
    },
  },
};
